// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 5308) return "static/chunks/5308-2552ebf0da9bd875.js";
	if (chunkId === 2617) return "static/chunks/519935c3-ae8833c1042c4d9b.js";
	if (chunkId === 344) return "static/chunks/344-fe223ab4ff14e013.js";
	if (chunkId === 3726) return "static/chunks/a453a474-cc66957e5cec17ed.js";
	if (chunkId === 6789) return "static/chunks/6789-bcafe6fa992522cf.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"5592":"c15bf2b0","6742":"281c3f4d"}[chunkId] || chunkId) + "." + {"376":"e664b4d3d96803a9","1797":"006f7c963aa262e6","3702":"7123d23fe1df72e5","3838":"a58d1a49c55de48d","4283":"9917ed1de4224e48","5417":"e48742a7696a6654","5592":"f35104e742f1e591","5693":"2471014c4483aeff","5802":"4572b88a31248547","6742":"7caf07e326c6840e"}[chunkId] + ".js";
};